import ExemptionNoticeViewModel from "viewModels/notice/exemption/exemptionNoticeViewModel";
import makeWidgetFor from "../../viewModels/makeWidgetFor";
import { registerWidget } from "../widget";
import InitializationWithOutagesService from "services/initialization/initializationWithOutagesService";

const ExemptionWidgetIdentifier = "edaz-exemption";

registerWidget({
  component: makeWidgetFor(ExemptionWidgetIdentifier, [ExemptionNoticeViewModel], InitializationWithOutagesService),
  configuration: {
    tagname: ExemptionWidgetIdentifier,
  },
});
